import { createI18n } from 'vue-i18n';

import de from '../locales/de.json';
import en from '../locales/en.json';
import fr from '../locales/fr.json';
import hu from '../locales/hu.json';

const lang = 'de';
export const supportedLocales = ['de', 'en', 'fr', 'hu'] as const;

export type SupportedLocale = (typeof supportedLocales)[number];

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: supportedLocales.includes(lang) ? lang : 'de',
  fallbackLocale: 'de',
  silentTranslationWarn: true,
  messages: {
    de,
    en,
    fr,
    hu,
  },
});

export const dateFormats: Record<SupportedLocale, string> = {
  de: 'dd. MM yy',
  en: 'dd/MM/yy',
  fr: 'dd/MM/yy',
  hu: 'yy.MM.dd',
};
